import { CircularProgress, Modal, Stack } from "@mui/material"
import { Game, GameIdentifier } from "shared-types/games"

interface Props {
    currentGame: Game
    url: string
    isGameLoading: boolean
    setIsGameLoading: (isLoading: boolean) => void
}

export const GameDisplayModal = ({ currentGame, isGameLoading, setIsGameLoading, url }: Props) => {

    const open = currentGame?.identifier === GameIdentifier.AIRCONSOLE || (currentGame?.identifier === GameIdentifier.THIS_IS_BLINDTEST && Boolean(currentGame.in_app));

    return (
        <Modal open={open}>
            <Stack
                sx={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {isGameLoading && <CircularProgress size={100} />}
                <iframe
                    title="game"
                    src={url}
                    style={
                        isGameLoading
                            ? { width: 0, height: 0 }
                            : { width: "100%", height: "100%" }
                    }
                    onLoad={() => setIsGameLoading(false)}
                    allow="autoplay; fullscreen"
                />
            </Stack>
        </Modal>
    )
}